import { Textarea } from "@/components/ui/textarea";

const OPTS = [["ok", "Va bene"], ["change", "Da cambiare"]];

function SectionCard({ s, fb, set, err, readOnly }) {
  const v = fb || { status: null, note: "" };
  const id = s.key.replace(/[^a-z0-9]/gi, "-");
  return (
    <div className={`space-y-2 rounded-lg border bg-white p-3 ${err ? "border-rose-300" : "border-slate-200"}`} data-testid={`review-sec-${id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="min-w-0 break-words text-sm font-medium text-slate-800">{s.label}</p>
        <div className="flex gap-1.5" role="group" aria-label={`Valutazione ${s.label}`}>{OPTS.map(([k, l]) => (
          <button key={k} type="button" disabled={readOnly} onClick={() => set({ ...v, status: k })} aria-pressed={v.status === k} data-testid={`review-sec-${id}-${k}`}
            className={`min-h-10 rounded-full border px-3.5 text-xs font-medium transition-colors disabled:cursor-default ${readOnly && v.status !== k ? "opacity-40 " : ""}${v.status === k ? (k === "ok" ? "border-emerald-600 bg-emerald-600 text-white" : "border-amber-500 bg-amber-500 text-white") : "border-slate-200 bg-white text-slate-700 hover:border-slate-400"}`}>{l}</button>))}</div>
      </div>
      {(v.status === "change" || v.note) && <Textarea rows={3} maxLength={1000} value={v.note} readOnly={readOnly} onChange={(e) => set({ ...v, note: e.target.value })}
        placeholder="Cosa vuoi cambiare? Es. testo, foto, colori, ordine" className={`text-sm ${readOnly ? "resize-none bg-slate-50" : ""}`} data-testid={`review-sec-${id}-note`} />}
      {err && <p className="text-xs text-rose-600" data-testid={`review-sec-${id}-err`}>{err}</p>}
    </div>);
}

// Feedback grouped by page: one choice + optional note per section, then general notes. Read-only once sent.
export default function FeedbackPanel({ grouped, feedback, set, errs, readOnly }) {
  const put = (k, v) => set({ ...feedback, sections: { ...feedback.sections, [k]: v } });
  return (
    <div className="space-y-5" data-testid="review-feedback">
      {grouped.map(([page, secs]) => (
        <section key={page} className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{page}</p>
          {secs.map((s) => <SectionCard key={s.key} s={s} fb={feedback.sections[s.key]} set={(v) => put(s.key, v)} err={errs[s.key]} readOnly={readOnly} />)}
        </section>))}
      <label className="block space-y-1.5">
        <span className="text-sm font-medium text-slate-800">Altre richieste o note generali (facoltative)</span>
        <Textarea rows={4} maxLength={3000} value={feedback.general} readOnly={readOnly} onChange={(e) => set({ ...feedback, general: e.target.value })} className={`text-sm ${readOnly ? "resize-none bg-slate-50" : ""}`} data-testid="review-general" />
      </label>
    </div>);
}
